export default "__VITE_ASSET__9c035701__"